import { BindParams, RootStore } from '@/components/DonationForm/types';
import { ComponentIds as Ids } from '@/components/DonationForm/constants';
import { makeAutoObservable } from 'mobx';
import { getSuggestedAmountMapper } from '@/common/utils/suggestedAmountToOptions';
import { CustomAmountItem } from '@/components/AmountWidget/constants';

import { DonationCampaign, DonationCampaignV1 } from '@/common/types';
import { ILocaleKeys } from '@/locale-keys';

const bindAmount = (rootStore: RootStore): BindParams => {
  const { $state, localeKeys, isV2 } = rootStore;

  const suggestedAmountToOption = getSuggestedAmountMapper(
    $state.currencyFormatter,
    isV2,
  );

  const amountState = makeAutoObservable({
    get options() {
      if ($state.isSuggestedAmountEnabled) {
        const amountList = isV2
          ? ($state.campaign as DonationCampaign)?.predefinedDonationAmounts
          : ($state.campaign as DonationCampaignV1)!.suggestedAmounts!.amounts;
        const options = amountList!.map(suggestedAmountToOption);

        if ($state.isCustomAmountEnabled) {
          return [...options, getOtherAmountOption(localeKeys)];
        }

        return options;
      }
      return [];
    },
    get minCustomAmount() {
      if (rootStore.isV2) {
        return ($state.campaign as DonationCampaign)?.customAmountOptions
          ?.minimum;
      }
      return ($state.campaign as DonationCampaignV1)?.customAmount?.minAmount;
    },
    get maxCustomAmount() {
      if (rootStore.isV2) {
        return ($state.campaign as DonationCampaign)?.customAmountOptions
          ?.maximum;
      }
      return ($state.campaign as DonationCampaignV1)?.customAmount?.maxAmount;
    },
  });

  return {
    [Ids.Amount]: {
      options: () => amountState.options,
      customAmountEnabled: () => $state.isCustomAmountEnabled,
      defaultValue: () => $state.amountDefaultValue,
      minCustomAmount: () => amountState.minCustomAmount,
      maxCustomAmount: () => amountState.maxCustomAmount,
      campaignId: () => $state.campaign?.id ?? '',
      onChange: (
        // @ts-expect-error
        { data },
      ) => {
        const isInputAmountValid = data && data > 0;
        $state.userInputAmount = isInputAmountValid ? data : undefined;
      },
    },
  };
};

const getOtherAmountOption = (localeKeys: ILocaleKeys) => ({
  value: CustomAmountItem,
  amountLabel: localeKeys.donationForm.otherAmount.button.defaultText(),
});

export default bindAmount;
